export default {
  title: 'Zaktualizuj czas dostarczenia',
  labels: {
    dropoff_time: 'Czas dostarczenia',
    confirmed: 'Potwierdzony czas:',
    new_time: 'Nowy czas:',
  },
  buttons: {
    save: 'Zapisz',
  },
  toasts: {
    success: 'Czas dostarczenia został pomyślnie zaktualizowany',
    failed_to_save: 'Nie udało się zapisać zmian',
  },
  alerts: {
    dropoff_time_info: 'Aktualny i nowy czas podane są w strefie czasowej {{restaurantName}} {{timezone}}',
  },
};
